/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";

export default graphql`
    query PieceRendererViewOriginalImageQuery($job_id: ID!) {
        music_viewer {
            note_original_image_extractor(job_id: $job_id) {
                image_download_url
                job_id
                job_status
            }
        }
    }
`;